module.exports = __webpack_public_path__ + "img/ring_r_s_1_null.676cb1ac.png";